import http from '@/utils/http';

export default {
	assignVehicle: data => http({ url: '/api/admin/v1/transport/assignVehicle', data, tip: true }),
	assignDriver: data => http({ url: '/api/admin/v1/transport/assignDriver', data, tip: true }),
	assignBatch: data => http({ url: '/api/admin/v1/transport/assignBatch', data, tip: true }),
	driverOptions: data => http({ url: '/api/admin/v1/transport/driverOptions', data }),
};
